import { render, staticRenderFns } from "./SimpleDynamicForm.vue?vue&type=template&id=bb9bf9d8&scoped=true&"
import script from "./SimpleDynamicForm.vue?vue&type=script&lang=js&"
export * from "./SimpleDynamicForm.vue?vue&type=script&lang=js&"
import style0 from "./SimpleDynamicForm.vue?vue&type=style&index=0&id=bb9bf9d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9bf9d8",
  null
  
)

export default component.exports